<div class="flex items-center justify-between">
  @if (status) {
    <span class="flex-1">
      Verifone: {{ status }}
      @if (cardType) {
        <span>({{ cardType }})</span>
      }
    </span>
  }
  @if (hasReceipt) {
    <button
      mat-icon-button
      matTooltip="Print Receipt"
      class="print-button shrink-0 mt-2"
      (click)="printReceipt()"
    >
      <mat-icon>print</mat-icon>
    </button>
  }
</div>
@if (receiptPreview) {
  <pre class="receipt-preview">{{ receiptPreview }}</pre>
  <span class="receipt-truncated">⋯</span>
}
@if (isPending) {
  <span class="pending-message"
    >Check the terminal and use Approve or Void to finalise this
    transaction.</span
  >
}
